import {useRef, useLayoutEffect } from "react";

// --- NEW: Reusable Auto-Growing Textarea Component ---
const AutoGrowTextarea = ({ minRows = 2, maxRows = 10, ...props }) => {
  const textareaRef = useRef(null);

  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to calculate the new scrollHeight correctly
      textarea.style.height = 'inherit';
      const scrollHeight = textarea.scrollHeight;
      
      // Define min and max heights based on row count and line height
      // This is an approximation but works well for most cases
      const lineHeight = parseFloat(window.getComputedStyle(textarea).lineHeight);
      const paddingTop = parseFloat(window.getComputedStyle(textarea).paddingTop);
      const paddingBottom = parseFloat(window.getComputedStyle(textarea).paddingBottom);
      const verticalPadding = paddingTop + paddingBottom;
      
      const minHeight = (minRows * lineHeight) + verticalPadding;
      const maxHeight = (maxRows * lineHeight) + verticalPadding;
      
      // Calculate the new height, constrained by min/max
      const newHeight = Math.max(minHeight, Math.min(scrollHeight, maxHeight));

      textarea.style.height = `${newHeight}px`;
      // Show scrollbar only when max height is reached
      textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
    }
  }, [props.value, minRows, maxRows]);

  return (
    <textarea
      ref={textareaRef}
      rows={minRows}
      {...props}
    />
  );
};

export default AutoGrowTextarea;